import { render } from "./App.vue?vue&type=template&id=2990e23b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/styles/app.styl?vue&type=style&index=0&lang=stylus"
import "@/assets/styles/base/_fonts.styl?vue&type=style&index=1&id=2990e23b&lang=stylus&scoped=true"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2990e23b"]])

export default __exports__